module.exports = __webpack_public_path__ + "img/palmas-room-4.bfa89b80.jpg";